module.exports = __webpack_public_path__ + "img/docker.2fdec4ae.svg";